import { css } from 'aphrodite';
import { UserMultiSelect } from '../../components/leadView/components/UserMultiSelect';
import { RepCard } from './RepCard';
import { styleSheet } from './repCards.styles';
import { ScoreAlertControls } from './ScoreAlertControls';
import { usePersistedRepCards } from './usePersistedRepCards';
import { useScoreAlertSettings } from './useScoreAlertSettings';

interface IProps {
	selectedConversationId: string | null;
	onSelectCall: (aiConversationId: string) => void;
}

/** Reps are picked manually — the manager's-team auto-roster is omitted while the API rejects `managerId`. */
export function RepCoachingCards({ selectedConversationId, onSelectCall }: IProps) {
	const [reps, setReps] = usePersistedRepCards();
	const [alertSettings, setAlertSettings] = useScoreAlertSettings();

	return (
		<div className={css(styleSheet.container)}>
			<div className={css(styleSheet.adminBar)}>
				<div className={css(styleSheet.adminBarField)}>
					<span className={css(styleSheet.adminBarLabel)}>Add reps</span>
					<UserMultiSelect users={reps} onChange={setReps} />
				</div>
				<ScoreAlertControls settings={alertSettings} onChange={setAlertSettings} />
			</div>
			{reps.length === 0 ? (
				<div className={css(styleSheet.cardState)}>Add a rep above to see their coaching cards.</div>
			) : (
				<div className={css(styleSheet.grid)}>
					{reps.map(rep => (
						<RepCard
							key={rep.id}
							repUser={rep}
							selectedConversationId={selectedConversationId}
							alertSettings={alertSettings}
							onSelectCall={onSelectCall}
							onRemove={() => setReps(prev => prev.filter(user => user.id !== rep.id))}
						/>
					))}
				</div>
			)}
		</div>
	);
}
